module.exports = __webpack_public_path__ + "assets/img/logo_top.e8e8378a.svg";